"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

// see styles in parent component
// this is a placeholder to use in auto-generating the styled component
var styles = function styles() {
  return "";
};

var _default = styles;
exports.default = _default;